import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldCheck, LogOut } from "lucide-react";
import { SupportFooter } from "@/components/SupportContact";

export default function AppShell({ children, subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-white border-b border-border sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/panel")} className="flex items-center gap-2" data-testid="header-logo">
            <img src="/eim-logo.png" alt="EIM" className="w-9 h-9 object-contain" />
            <span className="font-heading font-extrabold text-lg text-primary">EIM Becas</span>
          </button>
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-muted-foreground" data-testid="header-user">{user?.name}</span>
            <Button variant="ghost" size="sm" onClick={() => { logout(); navigate("/"); }} data-testid="btn-logout">
              <LogOut className="w-4 h-4 mr-1" /> Salir
            </Button>
          </div>
        </div>
      </header>
      {subtitle}
      <main className="max-w-5xl mx-auto px-5 py-8 fade-in">{children}</main>
      <SupportFooter />
    </div>
  );
}
